const archiveDate = () => {
  const currentDate = new Date();
  const lastYear = currentDate.getFullYear() - 1;
  const lastYearStartDate = new Date(lastYear, currentDate.getMonth(), currentDate.getDate());
  return lastYearStartDate;
};
  
export default archiveDate;
  